<div class="modal-header">
  <h4 class="modal-title">
    <span>{{ modalTitle | translate }}</span>
  </h4>
  <button
    type="button"
    *ngIf="showClose"
    class="btn-close"
    aria-label="Close"
    (click)="onDismissModal()"
  ></button>
</div>
<div class="modal-body">
  <ng-content></ng-content>
</div>
<div
  class="modal-footer"
  [ngClass]="{
    'd-flex justify-content-between': showDelete,
    'text-end': !showDelete
  }"
>
  <button class="btn btn-danger" (click)="onDeleteItem()" *ngIf="showDelete">
    <i class="fa fa-trash"></i>
    {{ "modalForm.deleteButton" | translate }}
  </button>
  <button
    *ngIf="hasRole"
    class="btn btn-primary btn-block"
    [ngClass]="{
      'btn-primary': isEditMode,
      'btn-secondary': !isEditMode,
      'btn-warning': isSaving
    }"
    (click)="onToggleEditMode()"
  >
    <ng-container *ngIf="isSaving">
      <i class="fa fa-spinner fa-spin"></i>
      {{ "modalForm.saveButtonSpinner" | translate }}
    </ng-container>
    <ng-container *ngIf="!isSaving">
      <i class="fa" [ngClass]="isEditMode ? 'fa-check' : 'fa-edit'"></i>
      {{
        isEditMode ? buttonTitle : ("modalForm.defaultButtonTitle" | translate)
      }}
    </ng-container>
  </button>
</div>
